import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import TOCHForceSignInComponent from './js/toch-force-sign-in/toch-force-sign-in.component';
import HeaderHeroComponent from './js/header-hero/header-hero.component';
import CompetitionQuestionComponent from './js/competition-question/competition-question.component';
import CompetitionListComponent from './js/competition-list/competition-list.component';
import InfluenceSurveyComponent from './js/influence/influence-survey.component';
import GenericBannerComponent from './js/generic-banner/generic-banner.component';
import InfluenceBlockComponent from './js/influence-block/influence-block.component';
import MasterCardRegistrationComponent from './js/mastercard-registration/mastercard-registration.component';
import CountdownComponent from './js/countdown/countdown.component';
import MastercardPromoPanelComponent from './js/mastercard-promo-panel/mastercard-promo-panel.component';
import CountdownAlertBarComponent from './js/countdown-alertbar/countdown-alertbar.component';
import OfferListComponent from './js/offer-list/offer-list.component';
import TOCHIMageGallery from './js/toch-image-gallery/toch-image-gallery.component';


ComponentsFactory.getInstance().define('toch-force-sign-in', TOCHForceSignInComponent);
ComponentsFactory.getInstance().define('competition-question', CompetitionQuestionComponent);
ComponentsFactory.getInstance().define('header-hero', HeaderHeroComponent);
ComponentsFactory.getInstance().define('competition-list', CompetitionListComponent);
ComponentsFactory.getInstance().define('influence-survey', InfluenceSurveyComponent);
ComponentsFactory.getInstance().define('generic-banner', GenericBannerComponent);
ComponentsFactory.getInstance().define('influence-block', InfluenceBlockComponent);
ComponentsFactory.getInstance().define('countdown', CountdownComponent);
ComponentsFactory.getInstance().define('mastercard-registration', MasterCardRegistrationComponent);
ComponentsFactory.getInstance().define('mastercard-promo-panel', MastercardPromoPanelComponent);
ComponentsFactory.getInstance().define('countdown-alertbar', CountdownAlertBarComponent);
ComponentsFactory.getInstance().define('offer-list', OfferListComponent);
ComponentsFactory.getInstance().define('toch-image-gallery', TOCHIMageGallery);
